import institutionAPI from 'services/institutionAPI'

export default async function checkUserToken() {
  const response = await institutionAPI({
    url: '/auth/person-auth/is-auth',
    method: 'POST',
  })

  return response
}
